import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmAside, IconLlmX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-menu.module.scss';

// export type PageMenuPlacement = 'left' | 'right';

export const PageMenu: React.FC = () => {
  const label = useLabel();
  const {
    PageHistory,
  } = useLlm(state => state.components);
  const asideEnabled = useLlm(state => state.asideEnabled);
  const history = useLlm(state => state.history);
  const { toggleAside } = useLlm(state => state.actions);
  return (
    <Ariakit.DialogProvider open={asideEnabled}>
      <Ariakit.DialogDisclosure render={(
        <button type="button" className={getClassNames(style.menu)}
          aria-label={asideEnabled ? label('llm.menuClose') : label('llm.menuOpen')}
          aria-pressed={asideEnabled}
          onClick={() => toggleAside()}
        >
          {<IconLlmAside />}
        </button>
      )}>
      </Ariakit.DialogDisclosure>
      <Ariakit.Dialog
        className={style.dialog}
        data-lenis-prevent
        backdrop={<div className={style.backdrop} />}
        onClose={() => toggleAside()}
      >
        <div className={style.head}>
          <IconLlmAside />
          <Ariakit.DialogHeading className={style.title}>Le tue ricerche</Ariakit.DialogHeading>
          <Ariakit.DialogDismiss render={
            <button className={getClassNames(style.close)}>
              <IconLlmX />
            </button>
          } />
        </div>
        <div className={style.listing}>
          {history.length > 0 ? (
            history.map((item, i) => (
              <PageHistory key={`history-${i}`} item={item} />
            ))
          ) : (
            <div className={style.empty}>{label('llm.historyEmpty')}</div>
          )}
        </div>
      </Ariakit.Dialog>
    </Ariakit.DialogProvider>
  );
};
